import { bunja } from 'bunja';
import { atom } from 'jotai';

import { fireYourPositionsManageClickEvent } from '@flipster/features/src/position-close-modal/segment';
import { accountBunja } from '@flipster/r230522/original/account';

import { yourPositionsBunja } from '../../../state';
import { openPositionRowDataBunja } from './row-bunja';

/**
 * 열린 포지션 TP/SL 셀 전용 데이터 레이어.
 *
 * 기존 셀은 `positionAtom`을 통째로 구독해, unrealizedPnl 등 표시무관 필드가 바뀌는 매 소켓 tick마다
 * 리렌더됐고 → memo된 TpSlCol/Set 버튼까지 매 tick 리렌더됐다. 렌더에는 안정적인 값만 필요하고,
 * pnl 같은 변동 값은 "클릭 순간"에만(analytics) 쓰이는데도 reactive prop으로 넘긴 게 원인이었다.
 *
 * TpslButton이 position에서 실제로 필요로 하는 건 identity(symbol·positionId)뿐이라, 렌더에는
 * row-bunja의 positionIdAtom(primitive)만 넘기면 된다(통짜 position 구독 불필요).
 *
 * - fireManageClickAtom: analytics 값(pnl·leverage 등)은 렌더가 아니라 클릭 시점에만 필요하므로
 *   prop 구독 대신 클릭 시 source atom에서 fresh 값을 읽어 이벤트를 발사한다.
 *   (row-bunja 주석대로 이 atom들엔 rAF 스로틀이 없어 source 값 그대로다.)
 */
export const openPositionTpslCellBunja = bunja(() => {
  const { positionAtom } = bunja.use(openPositionRowDataBunja);
  const { v2AccountAtom } = bunja.use(accountBunja);
  const { showAllSymbolAtom } = bunja.use(yourPositionsBunja);

  const fireManageClickAtom = atom(null, (get, _set, buttonText: 'Take profit' | 'Stop loss') => {
    const position = get(positionAtom);
    const tradeMode = get(v2AccountAtom)?.tradeMode;
    if (!position || !tradeMode) return;
    fireYourPositionsManageClickEvent(buttonText, {
      symbol: position.symbol,
      side: position.side,
      initLeverage: position.initLeverage,
      unrealizedPnl: position.unrealizedPnl,
      calcUnrealizedPnlPercent: position.calcUnrealizedPnlPercent,
      fundsInvested: position.fundsInvested,
      mode: tradeMode,
      isShowAll: get(showAllSymbolAtom),
      isProfitBoostMode: false,
      airdropType: position.airdropType,
    });
  });

  return { fireManageClickAtom };
});
openPositionTpslCellBunja.debugLabel = 'openPositionTpslCellBunja';
